.aboutContainer {
    display: flex;
    color: white;
    justify-content: space-between;
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 35px;
    font-size: 1.2em;
    box-sizing: border-box;
    width: 1100px;
    max-width: 100%;
}

.aboutContainer strong {
    margin-right: 10px;
}

@media (max-width: 800px) {
    /* a list of rows: the label on the left, the value on the right */
    .aboutContainer {
        flex-direction: column;
        padding-left: 24px;
        padding-right: 24px;
        font-size: 1.05em;
    }

    .aboutContainer > div {
        padding: 14px 0;
        border-bottom: 1px solid rgba(176, 178, 195, 0.25);
    }

    .aboutContainer > div:last-child {
        border-bottom: none;
    }

    .aboutContainer span {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        gap: 16px;
        text-align: right;
    }

    .aboutContainer strong {
        flex-shrink: 0;
        margin-right: 0;
    }
}
